import { RootState } from "@/store";
import { Address } from "@/types/address.types";

export const selectAllAddresses = (state: RootState): Address[] => state.addresses.addresses;
export const selectAddressesLoading = (state: RootState): boolean => state.addresses.loading;
export const selectAddressesError = (state: RootState): string | null => state.addresses.error;
export const selectSelectedIds = (state: RootState): string[] => state.addresses.selectedIds;
export const selectAddressById = (state: RootState, id: string): Address | undefined =>
  state.addresses.addresses.find((addr) => addr.id === id);
